/* global $, leaderboardData, queryString */
import React from 'react'
import ReactDOM from 'react-dom'
import cloneDeep from 'lodash/cloneDeep'
import Visual from 'bam-node-evp/dist/Visual'
// import SaveImage from './Download/index'
import schemaDefault from 'bam-node-evp/schema/default'
import Table from 'bam-node-savant-table/table'
import 'bam-node-evp/dist/styles.css'
import { getPitchName } from 'bam-node-baseball-savant/utils/pitch-names'
import filter from 'lodash/filter'
import { toFixed } from '../utils'

const schema = cloneDeep(schemaDefault)

// create table, pass in array of column objects and an array of row objects
// see wiki link below for examples of column and row objects
let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'spinAxis'

$('img.lazy').lazyload({
    effect: 'fadeIn',
    threshold: 300,
    skip_invisible: false,
    failure_limit: 15,
})

$(() => {
    $('#btnUpdate').click(() => {
        window.location.href = getUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${getUrl()}&csv=true`
    })
})

if (queryString.min) {
    $('#ddlMin').val(queryString.min).attr('selected', true)
    $('#lblMin').html(
        `Minimum Pitches (${$('#ddlMin option:selected').text()})`
    )
}

if (queryString.year) {
    $('#ddlSeason').val(queryString.year).attr('selected', true)
    $('#lblSeason').html($('#ddlSeason').val())
}

if (queryString.team) {
    $('#ddlTeamId').val(queryString.team).attr('selected', true)
    $('#lblTeamId').html($('#ddlTeamId option:selected').text())
}
if (queryString.pov) {
    $('#ddlPOV').val(queryString.pov).attr('selected', true)
    $('#lblPOV').html($('#ddlPOV option:selected').text())
}

if (queryString.pitch_type) {
    $('#ddlPitchType').val(queryString.pitch_type).attr('selected', true)
    $('#lblPitchType').html($('#ddlPitchType option:selected').text())
}
if (queryString.throws) {
    $('#ddlHand').val(queryString.throws).attr('selected', true)
    $('#lblHand').html($('#ddlHand option:selected').text())
}

if (queryString.sortDir) {
    $('#sortDir').val(queryString.sortDir)
}
if (queryString.sort) {
    $('#sort').val(queryString.sort)
}
if (queryString.playerName) {
    $('#txtPlayerSearch').val(queryString.playerName.toUpperCase())
    createTable(filterPlayers())
} else {
    createTable(leaderboardData)
}

function createTable(data) {
    if (!data?.length) {
        return
    }
    const secondaryHeaders = [
        {
            name: '',
            colspan: 7,
            headerClass: 'th-name-header',
        },
        {
            name: 'Pitch Movement',
            colspan: 4,
            headerClass: 'th-title-header',
        },
        {
            name: '',
            colspan: 1,
            headerClass: 'th-title-header',
        },
        {
            name: '',
            colspan: 1,
            headerClass: 'th-title-header',
        },
        {
            name: '',
            colspan: 1,
            headerClass: 'th-title-header',
        },
    ]

    const headers = [
        {
            name: 'Pitcher',
            field: 'href',
            headerClass: 'th-component-header align-left table-static-column',
            fieldClass: 'tr-data align-left table-static-column',
            photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
            photoId: 'player_id',
        },
        {
            name: 'Year',
            field: 'season',
            headerClass: 'th-component-header align-left',
            fieldClass: 'tr-data align-left',
        },
        {
            name: 'Throws',
            field: 'pitch_hand',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
        },
        {
            name: 'Pitch Type',
            field: 'api_pitch_type',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            displayFn: (value) => getPitchName(value),
        },
        {
            name: 'Pitches',
            field: 'n_pitches',
            type: 'number',
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
        },
        {
            name: 'MPH',
            field: 'release_speed',
            type: 'number',
            headerClass: 'th-component-header',
            fieldClass: 'tr-data',
            displayFn: toFixed(1, ''),
        },
        {
            name: 'Active <br/>Spin %',
            field: 'active_spin_formatted',
            type: 'number',
            headerClass: 'th-component-header border-left align-center',
            fieldClass: 'tr-data border-left align-center',
        },
        {
            name: 'Total <br/>Movement (In.)',
            field: 'movement_inches',
            type: 'number',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
            displayFn: toFixed(1, ''),
        },
        {
            name: 'Spin-Based',
            field: 'hawkeye_measured_clock_label',
            customSortField: 'hawkeye_measured_clock_minutes',
            type: 'number',
            headerClass: 'th-component-header  align-center',
            fieldClass: 'tr-data  align-center',
        },
        {
            name: 'Observed',
            field: 'movement_inferred_clock_label',
            customSortField: 'movement_inferred_clock_minutes',
            type: 'number',
            headerClass: 'th-component-header align-center',
            fieldClass: 'tr-data align-center',
        },
        {
            name: 'Deviation',
            customSortField: 'diff_measured_inferred_minutes',
            field: 'diff_clock_label',
            type: 'number',
            headerClass: 'th-component-header border-top border-left',
            fieldClass: 'tr-data border-left',
        },
        {
            name: 'Spin-Based',
            field: 'svgMeasured',
            // field: 'diff_clock_label',
            headerClass: 'th-component-header border-left border-right',
            fieldClass: 'tr-data  border-left border-right',
        },
        {
            name: 'Observed',
            field: 'svgInferred',
            // field: 'diff_clock_label',
            headerClass: 'th-component-header border-left border-right',
            fieldClass: 'tr-data border-left border-right',
        },
    ]

    const width = $(`#${tableDivId}`).outerWidth()
    let repeatHeaders = false
    if (width <= 768) {
        repeatHeaders = 15
    }

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader: repeatHeaders,
        secondaryHeaders,
        headers,
        defaultSort:
            headers[Number($('#sort').val())].customSortField ||
            headers[Number($('#sort').val())].field,
        defaultSortDirection: $('#sortDir').val(),
        sortClass: 'column-sort',
        // PASS IN UNIQUE ROW ID... Use this for ajax calls
        subDataId: 'uniqueId',
        showRank: true,
        data,
    })
}

function filterPlayers() {
    return filter(leaderboardData, (d) => {
        const playerName = d.player_name_last_first.toUpperCase()
        const searchName = $('#txtPlayerSearch').val().toUpperCase()
        return playerName.indexOf(searchName) > -1
    })
}

$(document).ready(() => {
    $('form').submit(false)
    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })
    $('#ddlPOV').change(() => {
        $('#lblPOV').html($('#ddlPOV option:selected').text())
    })

    $('#ddlPitchType').change(() => {
        $('#lblPitchType').html($('#ddlPitchType option:selected').text())
    })
    $('#ddlHand').change(() => {
        $('#lblHand').html($('#ddlHand option:selected').text())
    })

    $('#ddlSeason').change(() => {
        $('#lblSeason').html($('#ddlSeason').val())
    })
    $('#ddlMin').change(() => {
        $('#lblMin').html(
            `Minimum Pitches (${$('#ddlMin option:selected').text()})`
        )
    })

    $('#txtPlayerSearch').keyup(() => {
        createTable(filterPlayers())
        populateUrl()
    })

    $(`#${tableDivId}`).on(
        'click',
        '.default-table-row',
        function clickHandler() {
            const splitId = this.id.split('_')[1]
            const playerId = splitId.split('-')[0]

            if ($(`#${tableDivId}-trSub_${splitId}`).is(':visible') === true) {
                $(`#${tableDivId}-trSub_${splitId}`).hide()
            } else {
                $.ajax({
                    method: 'GET',
                    url: '/savant/api/v1/spin-direction-by-pitcher',
                    data: {
                        pitcher: playerId,
                        year: $('#ddlSeason').val(),
                        pov: $('#ddlPOV').val(),
                    },
                }).done((json) => {
                    $(`#${tableDivId}-tdSub_${splitId}`).html(
                        `
                    <div>
                        <div style="display: inline-block;" id="data_meas_${splitId}"></div>
                        <div style="display: inline-block;" id="data_infer_${splitId}"></div>
                    </div>
                    `
                    )
                    $(`#${tableDivId}-trSub_${splitId}`).show()

                    const iData = []
                    for (let i = 0; i < json.length; i++) {
                        const d = json[i]
                        d.x = String(d.rn_clock)
                        d.y = d.infer_n_pitches
                        iData.push(d)
                    }
                    schema.charts = [
                        {
                            chartType: 'pitch',
                            overlayType: 'spinAxis',
                            legendType: 'pitchName',
                            showPlate: false,
                            legend: true,
                        },
                    ]
                    schema.sourcePlate.siteTitle = `SPIN DIRECTION - ${$(
                        '#ddlPOV option:selected'
                    )
                        .text()
                        .toUpperCase()}`
                    schema.sourcePlate.sourceTitle = 'promo'

                    schema.namePlate.photoId = playerId
                    schema.namePlate.primaryTitleText =
                        json[0].player_name_last_first
                    schema.namePlate.secondaryTitleFontSize = '.85rem'
                    schema.namePlate.secondaryTitleText =
                        'Observed Total Movement by Pitch Type'
                    schema.namePlate.secondaryFontColor = '#b00'

                    ReactDOM.render(
                        <Visual data={iData} chart={schema} />,
                        document.getElementById(`data_infer_${splitId}`)
                    )

                    const mData = []
                    for (let i = 0; i < json.length; i++) {
                        const d = json[i]
                        d.x = String(d.rn_clock)
                        d.y = d.meas_n_pitches
                        mData.push(d)
                    }

                    schema.charts[0].pitchTypes = [
                        'meas_n_ff',
                        'meas_n_si',
                        'meas_n_fc',
                        'meas_n_ch',
                        'meas_n_sl',
                        'meas_n_cu',
                        'meas_n_fs',
                        'meas_n_st',
                        'meas_n_sv',
                        'meas_n_sc',
                        'meas_n_fo',
                        'meas_n_kc',
                    ]

                    const mSchema = cloneDeep(schema)
                    mSchema.namePlate.secondaryTitleText =
                        'Spin-Based Movement by Pitch Type'
                    mSchema.namePlate.secondaryTitleFontSize = '.85rem'
                    ReactDOM.render(
                        <Visual data={mData} chart={mSchema} />,
                        document.getElementById(`data_meas_${splitId}`)
                    )
                })
            }
        }
    )

    window.addEventListener('scroll', () => {
        if (!ticking && leaderboardData.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $(`#${divId} table .default-table-row`)
                .first()
                .children('td')
                .each(function eachHandler() {
                    const widthEach = $(this).outerWidth()
                    $(
                        `#${divId} table .tr-component-row th:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', widthEach)
                    tableCell += 1
                })

            $(`#${divId} table thead`).first().addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $(`#${divId} table .tr-component-row`)
                .children('th')
                .each(function eachHandler() {
                    const widthEach = $(this).outerWidth()
                    $(
                        `#${divId} table .default-table-row td:nth-child(${
                            tableCell + 1
                        })`
                    ).css('width', widthEach)
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $(document).on('click', 'th.th-component-header', function clickHandler() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })
})

function populateUrl() {
    const url = getUrl()

    window.history.pushState('', '', url)
    return url
}

function getUrl() {
    return `/leaderboard/spin-direction-pitches?year=${$(
        '#ddlSeason'
    ).val()}&min=${$('#ddlMin').val()}&sort=${$('#sort').val()}&sortDir=${$(
        '#sortDir'
    ).val()}&pitch_type=${$('#ddlPitchType').val()}&throws=${$(
        '#ddlHand'
    ).val()}&playerName=${$('#txtPlayerSearch').val()}&team=${$(
        '#ddlTeamId'
    ).val()}&pov=${$('#ddlPOV').val()}`
}
